import Particles from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { useCallback } from 'react';
import { useTheme } from './ThemeContext';

const Background = () => {
  const { isDarkMode } = useTheme();

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const options = {
    fullScreen: false,
    background: {
      color: isDarkMode ? "#13162a" : "#F0F4F8"
    },
    fpsLimit: 120,
    particles: {
      color: {
        value: isDarkMode ? "#ffffff" : "#1E213A",
      },
      links: {
        color: isDarkMode ? "#ffffff" : "#1E213A",
        distance: 150,
        enable: true,
        opacity: 0.2,
        width: 1
      },
      move: {
        enable: true,
        speed: 0.8
      },
      number: {
        density: {
          enable: true,
          area: 800
        },
        value: 80
      },
      opacity: {
        value: 0.3
      },
      shape: {
        type: "circle"
      },
      size: {
        value: { min: 1, max: 3 }
      }
    },
    detectRetina: true
  };

  return (
    <div className="fixed inset-0 -z-10">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={options}
        className="absolute inset-0"
      />
    </div>
  );
};

export default Background;